import { XButton } from '#assets/svg';
import { Text } from '#atoms';
import { Modal } from '#molecules';
import { Button } from '#pages/DashboardCustomer/styles';

interface UploadTypeModalProps {
  onClose: () => void;
  setUploadType: (type: '통합' | '운동별') => void;
}
export const UploadTypeModal = ({
  onClose,
  setUploadType
}: UploadTypeModalProps) => {
  const onTotalUpload = () => {
    setUploadType('통합');
    onClose();
  };

  const onExerciseUpload = () => {
    setUploadType('운동별');
    onClose();
  };

  return (
    <Modal style={{ padding: '24px' }} onClose={onClose}>
      <div className="flex justify-between w-full">
        <Text textStyle="t3">사진 및 영상 업로드</Text>
        <XButton onClick={onClose} />
      </div>

      <div className="w-full flex flex-col gap-8">
        <Button onClick={onTotalUpload}>
          <div className="title">통합 업로드</div>
          <div className="desc">
            운동 종류와 상관없이 <br /> 한 번에 업로드해요.
          </div>
        </Button>
        <Button onClick={onExerciseUpload}>
          <div className="title">운동별 업로드</div>
          <div className="desc">
            운동 종류마다 해당되는 <br /> 사진 및 영상를 업로드해요.
          </div>
        </Button>
      </div>
    </Modal>
  );
};
